import { baseErrorResponseSchema, baseResponseSchema } from 'api/api.config';
import { z } from 'zod';

export const verifyDocumentResponseSchema = baseResponseSchema.extend({});

export type VerifyDocumentResponseIType = z.infer<
  typeof verifyDocumentResponseSchema
>;

export const verifyDocumentErrorResponseSchema = baseErrorResponseSchema;

export type VerifyDocumentErrorResponseIType = z.infer<
  typeof verifyDocumentErrorResponseSchema
>;

export const isVerifyDocumentErrorResponse = (
  response: unknown,
): response is VerifyDocumentErrorResponseIType => {
  return verifyDocumentErrorResponseSchema.safeParse(response).success;
};
